module.exports = __webpack_public_path__ + "img/pegawai_ijin_hari_ini.ac5de7eb.png";